import Button from '@mui/material/Button';

import Dialog from '@mui/material/Dialog';

import DialogActions from '@mui/material/DialogActions';

import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';
import { useTheme ,Theme  } from '@mui/material';
import Typography from '@mui/material/Typography';

//| import { Theme } from '@mui/material/styles';

import { makeStyles } from '@mui/styles';

import { createStyles } from '@mui/styles';

import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';

import moment, { Moment } from 'moment';

import { useState } from 'react';

import { DateSpan } from '../../store/config/enums';

import { PaymentsFilters } from '../../store/config/types';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      width: '100%',
      textAlign: 'center',
    },
    dialog: {
      display: 'flex',
      flexDirection: 'row',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    picker: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: '1rem',
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
      },
    },
    from: {
      marginTop: '0.6rem',
      marginRight: '0.6rem',
      [theme.breakpoints.down('sm')]: {
        margin: 0,
      },
    },
    to: {
      marginTop: '0.6rem',
      marginLeft: '0.6rem',
      [theme.breakpoints.down('sm')]: {
        margin: 0,
      },
    },
  }),
);

interface DateRangeDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  filters: PaymentsFilters | null;
  setFilters: (filters: PaymentsFilters) => void;
}

function DateRangeDialog({ isOpen, setIsOpen, filters, setFilters }: DateRangeDialogProps) {
  const classes = useStyles(useTheme());
  // use undefined for optional values to satisfy PaymentsFilters typing
  const [fromDate, setFromDate] = useState<Moment | undefined>(moment().startOf('day'));
  const [toDate, setToDate] = useState<Moment | undefined>(moment().endOf('day'));

  const closeDialog = () => {
    setFilters({ ...filters, dateSpan: DateSpan.ALL });
    setIsOpen(false);
  };

  const handleFromChange = (newValue: Moment | null) => {
    setFromDate(newValue ? moment(newValue).startOf('day') : undefined);
  };

  const handleToChange = (newValue: Moment | null) => {
    setToDate(newValue ? moment(newValue).endOf('day') : undefined);
  };

  const submitRange = () => {
    setIsOpen(false);
    setFilters({
      ...filters,
      dateSpan: DateSpan.CUSTOM,
      // use undefined instead of null to match PaymentsFilters (string | undefined)
      from: fromDate ? fromDate.toISOString() : undefined,
      to: toDate ? toDate.toISOString() : undefined,
    });
  };

  return (
    <Dialog open={isOpen} onClose={closeDialog} className="dialog">
      <DialogTitle className="dialog-title">
        <Typography variant="h4" className={classes.title}>
          Selecciona un rango de fechas
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.dialog}>
        <div className={classes.picker}>
          <Typography variant="h5">Desde</Typography>
          <div className={classes.from}>
            <StaticDatePicker
              maxDate={toDate}
              disableFuture
              value={fromDate}
              onChange={handleFromChange}
            />
          </div>
        </div>
        <div className={classes.picker}>
          <Typography variant="h5">Hasta</Typography>
          <div className={classes.to}>
            <StaticDatePicker disableFuture value={toDate} onChange={handleToChange} />
          </div>
        </div>
      </DialogContent>
      <DialogActions className="date-dialog-actions">
        <Button variant="text" onClick={closeDialog}>
          Cancelar
        </Button>
        <Button variant="contained" color="primary" onClick={submitRange}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DateRangeDialog;

